<template>
  <v-container grid-list-xl class="pa-0 pb-4" id="order-tools-page">
    <v-layout row wrap>
      <v-flex xs6 class="mt-2 pb-0">
        <v-btn text outlined color="primary" to="/tools/order">
          <v-icon small class="mr-1">chevron_left</v-icon>back to tools
        </v-btn>
      </v-flex>
      <v-flex xs6 class="mt-2 pb-0 text-right">
        <h3 class="pr-2 title">Checkout Cart</h3>
      </v-flex>
      <v-flex xs12>
        <v-card
          elevation="1"
          class="mb-4"
          v-if="newCart.length && !orderPlaced"
        >
          <v-card-text class="px-2">
            <v-simple-table>
              <tbody>
                <tr v-for="tool in newCart" :key="tool.id">
                  <td class="pa-2">
                    <v-img :src="tool.image" width="60" height="60" contain />
                  </td>
                  <td>
                    <div class="mb-2">
                      {{ tool.title }}
                      <br /><span
                        class="caption secondary--text text--darken-4"
                        v-if="tool.consumable && tool.unitPrice"
                        >Unit Price: ${{ tool.unitPrice.toFixed(2) }}</span
                      >
                    </div>
                    <v-icon @click="minusQty(tool.id)" :disabled="tool.qty == 1"
                      >remove_circle_outline</v-icon
                    >
                    <v-text-field
                      class="d-inline-block centered-input qty"
                      name="qty"
                      v-model.number="tool.qty"
                      style="width:60px"
                      type="number"
                      @blur="$store.commit('newOnBlur')"
                      :dense="true"
                    ></v-text-field>
                    <v-icon @click="plusQty(tool.id)"
                      >add_circle_outline</v-icon
                    >
                  </td>
                  <td class="text-right">
                    <v-icon
                      color="grey lighten-1"
                      @click="$store.commit('removeNewCartItem', tool.id)"
                      >cancel</v-icon
                    >
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
            <v-flex xs12 class="pt-4">
              <div v-if="consumablesCost > 0">
                Consumables Cost:
                <strong style="border-bottom: solid 3px orange"
                  >${{ utils.numberWithCommas(consumablesCost) }}</strong
                >
              </div>
              <v-textarea
                outlined
                label="Additional Notes"
                class="mt-4"
                v-model="notes"
              ></v-textarea>
              <v-col cols="12" xs="12" sm="6" md="5" class="pa-0 ma-0">
                <job-selector @jobSiteChange="jobSite = $event" />
              </v-col>
              <v-col cols="12" xs="12" sm="6" md="5" class="pa-0 ma-0">
                <v-select
                  :items="requestDays"
                  v-model="requestDay"
                  label="Request Day (REQUIRED)"
                  item-value="displayDate"
                  item-text="displayDate"
                  prepend-icon="event"
                  return-object
                ></v-select>
              </v-col>
              <v-col cols="12" xs="12" sm="6" md="5" class="pa-0 ma-0">
                <v-select
                  :items="[
                    '6am',
                    '7am',
                    '8am',
                    '9am',
                    '10am',
                    '11am',
                    '12pm',
                    '1pm',
                    '2pm',
                    '3pm',
                    '4pm',
                    '5pm',
                    '6pm',
                    '7pm',
                    '8pm',
                    '9pm',
                    '10pm',
                  ]"
                  v-model="requestTime"
                  label="Request Time (REQUIRED)"
                  item-value="displayDate"
                  item-text="displayDate"
                  prepend-icon="access_time"
                  return-object
                ></v-select>
              </v-col>
            </v-flex>
            <v-alert dense outlined type="error" v-if="isAfterCutoffTime">
              You are placing a late request and may not receive your order
              until the next business day.<br />
              <strong>Please place future orders by 12:30pm</strong>
            </v-alert>
          </v-card-text>
          <v-card-actions class="pa-3 text-right">
            <v-btn
              @click="placeToolOrder"
              color="primary"
              :disabled="submittingOrder"
              :loading="submittingOrder"
              large
              block
            >
              <v-icon class="mr-3" small>shopping_cart</v-icon>Place Tool Order
            </v-btn>
          </v-card-actions>
        </v-card>
        <!-- START - no items in cart -->
        <v-card v-if="!newCart.length && !orderPlaced && !reloadedOrder.length">
          <v-card-text class="text-center">
            <h1 class="title">
              There are no items in the cart.
              <br />
              <br />Please go back to the tools list and add items before
              placing an order.
              <br />
              <br />
            </h1>
            <v-btn text outlined color="primary" to="/tools/order">
              <v-icon small left>chevron_left</v-icon>back to tools
            </v-btn>
          </v-card-text>
        </v-card>
        <!-- END - no items in cart -->
        <v-card v-if="orderPlaced">
          <v-card-text class="text-center">
            <v-icon x-large color="green">check_circle</v-icon>
            <br />
            <br />
            <h1 class="title">
              Your order has been placed!
              <br />
            </h1>
            <p>
              The yard has been notified. You will receive an email when the
              order is fulfilled.
            </p>
            <v-btn text outlined color="primary" to="/tools/orders">
              <v-icon small left>chevron_left</v-icon>go to open orders
            </v-btn>
          </v-card-text>
        </v-card>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import fb from "@/main";
import utils from "@/helpers/utils";
import { mapState } from "vuex";
import { sum } from "lodash";
import moment from "moment";
import JobSelector from "../components/JobSelector";
export default {
  components: { JobSelector },
  data: () => ({
    fab: false,
    loadingTools: true,
    categoryFilterItem: null,
    notes: "",
    jobSite: null,
    notifications: false,
    cartItems: [],
    snack: false,
    snackColor: "",
    snackText: "",
    orderPlaced: false,
    submittingOrder: false,
    requestDay: {},
    requestDays: [],
    requestTime: "",
    utils: utils,
  }),
  computed: {
    ...mapState(["user", "newCart", "reloadedOrder"]),
    consumablesCost() {
      let consumables = this.newCart.filter((nc) => nc.consumable);
      const val = consumables.map(
        (nc) => parseFloat(nc.unitPrice) * parseFloat(nc.qty),
        2
      );
      return sum(val).toFixed(2);
    },
    isAfterCutoffTime() {
      const now = moment();
      const cutoffTime = moment().set({
        hour: 9,
        minute: 30,
        second: 0,
      });
      return now.isAfter(cutoffTime);
    },
  },
  methods: {
    async placeToolOrder() {
      try {
        if (!this.jobSite) {
          alert("Please select a job Site.");
          return;
        }
        if (!this.requestDay.displayDate) {
          alert("Please select a request day. When you want it delivered.");
          return;
        }
        if (!this.requestTime) {
          alert("Please select request time. What time you want it delivered.");
          return;
        }
        this.submittingOrder = true;
        await fb.db.runTransaction(async (transaction) => {
          // Get the metadata document and increment the count.
          const metaRef = fb.db.doc("metadata/toolOrders");
          const metaData = (await transaction.get(metaRef)).data() || {};

          const number = metaData.count + 1;

          transaction.update(metaRef, {
            count: number,
          });

          // Update the order document
          const orderRef = fb.db
            .collection("toolOrders")
            .doc(number.toString());

          transaction.set(orderRef, {
            tools: this.newCart,
            orderedBy: this.user,
            jobSite: this.jobSite,
            notes: this.notes,
            orderDate: fb.timestamp,
            orderNumber: number.toString(),
            status: "open",
            toolIds: this.newCart.map((ci) => ci.id),
            fulfillments: [],
            requestDay: this.requestDay,
            requestTime: this.requestTime,
          });
        });
        this.submittingOrder = false;
        this.orderPlaced = true;
        this.$store.commit("newResetToolQty");
        this.notes = "";
        this.jobSite = null;
        this.requestDay = {};
        this.requestTime = "";
      } catch (error) {
        alert("Error submitting order.");
      }
    },
    minusQty(id) {
      this.$store.commit("newMinusQty", id);
    },
    plusQty(id) {
      this.$store.commit("newPlusQty", id);
    },
  },
  async created() {
    for (let daysBack = 7; daysBack > -1; daysBack--) {
      let day = moment().add(daysBack, "d");
      this.requestDays.push({
        displayDate: day.format("MMM Do (dddd)"),
        requestDate: day.toDate(),
      });
    }
    this.requestDays.reverse();
    // check if tools are being reloaded from previous order
    if (this.reloadedOrder.length) {
      await this.$store.dispatch("reloadToolsFromPreviousOrder");
    }
    // load tools from local storage if any
    this.$store.dispatch("loadToolsFromLocal");
  },
};
</script>
